/**
 * SiteDetail 페이지에서 사용하는 아이콘 컴포넌트들
 *
 * 공통 SVG는 `components/icons`에서 재수출한다(중복 정의 금지).
 * 여기엔 이 페이지에서만 쓰는 것만 둔다.
 */
export {
  ChevronRightIcon,
  ChevronLeftIcon,
  ChevronDownIcon as ChevronIcon,
  AlertTriangleIcon as ExclamationIcon,
  XIcon,
  ClockIcon,
  XCircleIcon,
} from '../../../../components/icons';

interface IconProps {
  className?: string;
}

export function UserGroupIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
  );
}

export function GripVerticalIcon({ className }: IconProps) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
      <circle cx="6" cy="3" r="1.2" />
      <circle cx="10" cy="3" r="1.2" />
      <circle cx="6" cy="8" r="1.2" />
      <circle cx="10" cy="8" r="1.2" />
      <circle cx="6" cy="13" r="1.2" />
      <circle cx="10" cy="13" r="1.2" />
    </svg>
  );
}
